import Point3D from '../geom/Point3D.js';

function BoundingBoxDT(minx, maxx, miny, maxy) {
    minx = (typeof minx === 'undefined') ? NaN : minx;
    maxx = (typeof maxx === 'undefined') ? NaN : maxx;
    miny = (typeof miny === 'undefined') ? NaN : miny;
    maxy = (typeof maxy === 'undefined') ? NaN : maxy;
    if (isNaN(minx) || isNaN(maxx) || isNaN(miny) || isNaN(maxy)) {
        this.setToNull();
    } else {
        this.init(minx, maxx, miny, maxy);
    }
}

BoundingBoxDT.createFrom = function(other) {
    var result;
    if (other.isNull()) {
        result = new BoundingBoxDT();
    } else {
        result = new BoundingBoxDT(other.minX, other.maxX, other.minY, other.maxY);
    }
    return result;
};

BoundingBoxDT.createFromBounds = function(minx, maxx, miny, maxy) {
    return new BoundingBoxDT(minx, maxx, miny, maxy);
};

BoundingBoxDT.createFromLowerLeftAndUpperRight = function(lowerLeft, upperRight) {
    return new BoundingBoxDT(lowerLeft.x, upperRight.x, lowerLeft.y, upperRight.y);
};


BoundingBoxDT.prototype = {


    init: function(x1, x2, y1, y2) {
        if (x1 < x2) {
            this.minX = x1;
            this.maxX = x2;
        } else {
            this.minX = x2;
            this.maxX = x1;
        }
        if (y1 < y2) {
            this.minY = y1;
            this.maxY = y2;
        } else {
            this.minY = y2;
            this.maxY = y1;
        }
    },

    /**
     *  Makes this BoundingBox a "null" envelope, that is, the envelope
     *  of the empty geometry.
     */
    setToNull: function() {
        this.minX = 0;
        this.maxX = -1;
        this.minY = 0;
        this.maxY = -1;
    },

    isNull: function() {
        return this.maxX < this.minX;
    },

    contains: function(other) {
        return !(this.isNull() || other.isNull()) &&
            other.minX >= this.minX &&
            other.maxY <= this.maxX &&
            other.minY >= this.minY &&
            other.maxY <= this.maxY;
    },

    /**
     * Unify the BoundingBoxes of this and the other BoundingBox
     * @param other     another BoundingBox
     * @return              The union of the two BoundingBoxes
     */
    unionWith: function(other) {
        if (other.isNull()) {
            return BoundingBoxDT.createFrom(this);
        }
        if (this.isNull()) {
            return BoundingBoxDT.createFrom(other);
        } else {
            return new BoundingBoxDT(
                Math.min(this.minX, other.minX),
                Math.max(this.maxX, other.maxX),
                Math.min(this.minY, other.minY),
                Math.max(this.maxY, other.maxY));
        }
    },

    /**
     * @return  Width of the bounding box
     */
    getWidth: function() {
        return this.maxX - this.minX;
    },

    /**
     * @return  Height of the bounding box
     */
    getHeight: function() {
        return this.maxY - this.minY;
    },

    /**
     * @return      Maximum coordinate of bounding box
     */
    getMinPoint: function() {
        return new Point3D(this.minX, this.minY);
    },

    /**
     * @return      Minimum coordinate of bounding box
     */
    getMaxPoint: function() {
        return new Point3D(this.maxX, this.maxY);
    }

};

export default BoundingBoxDT;